var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { isClient } from "../utils";
import { actions } from "../BasicReducer";
import { unselectAllDocuments } from "../Library/actions/libraryActions";
import { wrapDispatch } from "../Multireducer";
import RouteHandler from "../App/RouteHandler";
import ViewMetadataPanel from "../Library/components/ViewMetadataPanel";
import SelectMultiplePanelContainer from "../Library/containers/SelectMultiplePanelContainer";
import { withRouter } from "../componentWrappers";
import { trackPage } from "../App/GoogleAnalytics";
import { ErrorBoundary } from "../V2/Components/ErrorHandling";
import { PageViewer } from "./components/PageViewer";
import { getPageAssets } from "./utils/getPageAssets";
import { updatePageDatasets } from "./utils/updatePageDatasets";

class PageViewComponent extends RouteHandler {
  static async requestState(requestParams) {
    try {
      const { pageView, itemLists, datasets } = await getPageAssets(requestParams);
      return [
      actions.set('page/pageView', pageView),
      actions.set('page/itemLists', itemLists),
      actions.set('page/datasets', datasets)];

    } catch (e) {
      return [actions.set('page/error', e)];
    }
  }

  closeSidePanel() {
    wrapDispatch(this.context.store.dispatch, 'library')(unselectAllDocuments());
  }

  componentDidMount() {
    this.closeSidePanel();
    if (isClient) {
      window.updatePageDatasets = updatePageDatasets;
    }
  }

  componentWillUnmount() {
    this.emptyState();
  }

  emptyState() {
    this.closeSidePanel();
    this.context.store.dispatch(actions.unset('page/pageView'));
    this.context.store.dispatch(actions.unset('page/itemLists'));
    this.context.store.dispatch(actions.unset('page/datasets'));
    this.context.store.dispatch(actions.unset('page/error'));
  }

  setReduxState(state) {
    this.context.store.dispatch(actions.set('page/pageView', state.page.pageView));
    this.context.store.dispatch(actions.set('page/itemLists', state.page.itemLists));
    this.context.store.dispatch(actions.set('page/datasets', state.page.datasets));
    this.context.store.dispatch(actions.set('page/error', state.page.error));
  }

  render() {
    trackPage();
    return (/*#__PURE__*/
      _jsx(ErrorBoundary, {}, void 0, /*#__PURE__*/
      _jsx(PageViewer, {}), /*#__PURE__*/
      _jsx(ViewMetadataPanel, { storeKey: "library" }), /*#__PURE__*/
      _jsx(SelectMultiplePanelContainer, { storeKey: "library" })
      ));

  }
}

const SSRPageView = withRouter(PageViewComponent);

export const PageView = Object.assign(SSRPageView, {
  requestState: PageViewComponent.requestState
});

export default PageViewComponent;